import moment from 'moment';

import {
  LOAD_TRAVEL_PAST_MOCK_DATA,
  FETCH_TRAVEL_PAST_SUMMARY,
  FETCH_TRAVEL_PAST_SUMMARY_ERROR,
  SET_TRAVEL_PAST_SUMMARY,
  FETCH_TRAVEL_PAST_POI_COUNT,
  SET_TRAVEL_PAST_POI_COUNT,
  FETCH_TRAVEL_PAST_OVER_TIME,
  FETCH_TRAVEL_PAST_OVER_TIME_ERROR,
  SET_TRAVEL_PAST_OVER_TIME,
  FETCH_TRAVEL_PAST_DAILY_AVERAGES,
  FETCH_TRAVEL_PAST_DAILY_AVERAGES_ERROR,
  SET_TRAVEL_PAST_DAILY_AVERAGES,
  FETCH_TRAVEL_PAST_POIS,
  FETCH_TRAVEL_PAST_POIS_ERROR,
  SET_TRAVEL_PAST_POIS,
  FETCH_TRAVEL_PAST_REPEAT_DEVICES,
  FETCH_TRAVEL_PAST_REPEAT_DEVICES_ERROR,
  SET_TRAVEL_PAST_REPEAT_DEVICES,
  DOWNLOAD_TRAVEL_PAST_INSIGHTS,
  DOWNLOAD_TRAVEL_PAST_INSIGHTS_SUCCESS,
  DOWNLOAD_TRAVEL_PAST_INSIGHTS_FAILURE,
  SELECT_TRAVEL_PAST_TIME_PERIOD,
  SELECT_TRAVEL_PAST_AVERAGE,
  LOG_OUT,
} from '../constants';

const initialState = {
  title: 'New Zealand',
  subtitle: '',
  suburb: null,
  city: null,
  district: null,
  organisationId: '5c5400b9e34276000469f35a',
  sinceDate: moment().subtract(12, 'months').startOf('month').format(),
  untilDate: moment().subtract(1, 'months').endOf('month').format(),
  selectedAverage: {},
  averageFilter: "month",
  summaryLoaded: false,
  summaryError: false,
  summaryData: {
    eventsCount: 0,
    devicesCount: 0,
    poisCount: 0,
    poisTotalCount: 0,
  },
  overTimeLoaded: false,
  overTimeError: false,
  overTimeData: [],
  dailyAveragesLoaded: false,
  dailyAveragesError: false,
  dailyAveragesData: {
    Mon: 0,
    Tue: 0,
    Wed: 0,
    Thu: 0,
    Fri: 0,
    Sat: 0,
    Sun: 0,
    percent: {
      Mon: 0,
      Tue: 0,
      Wed: 0,
      Thu: 0,
      Fri: 0,
      Sat: 0,
      Sun: 0,
    },
  },
  poisLoaded: false,
  poisError: false,
  poisData: [],
  repeatDevicesLoaded: false,
  repeatDevicesError: false,
  repeatDevicesData: {
    repeatPercent: 0,
    uniquePercent: 0,
    averageEvents: 0,
    averageEventsByPOI: 0,
  },
  travelPastPoiCountLoaded: false,
  travelPastPoiCountData: {},
  downloadingCSV: false,
  csvType: null,
  selectedPeriod: {
    label: 'Last 90 days',
    value: 90
  },
};

const travelPast = (state = initialState, action) => {
  switch (action.type) {
    case LOG_OUT:
      return {
        ...initialState,
      };
    case LOAD_TRAVEL_PAST_MOCK_DATA:
      return {
        ...state,
        ...action.mockData,
      };
    case SELECT_TRAVEL_PAST_TIME_PERIOD:
      return {
        ...state,
        selectedPeriod: action.selectedPeriod,
      };
    case SELECT_TRAVEL_PAST_AVERAGE:
      {
        const resp = {
          ...state,
          selectedAverage: action.selectedAverage,
          averageFilter: null
        };

        if (action.selectedAverage) resp.averageFilter = action.selectedAverage.value;

        return resp;
      }
    case FETCH_TRAVEL_PAST_SUMMARY:
      return {
        ...state,
        summaryLoaded: false,
      };
    case FETCH_TRAVEL_PAST_SUMMARY_ERROR:
      return {
        ...state,
        summaryError: true,
      };
    case SET_TRAVEL_PAST_SUMMARY:
      return {
        ...state,
        summaryLoaded: true,
        summaryData: action.data,
      };
    case FETCH_TRAVEL_PAST_POI_COUNT:
      return {
        ...state,
        travelPastPoiCountLoaded: false,
      };
    case SET_TRAVEL_PAST_POI_COUNT:
      return {
        ...state,
        travelPastPoiCountLoaded: true,
        travelPastPoiCountData: action.data,
      };
    case FETCH_TRAVEL_PAST_OVER_TIME:
      return {
        ...state,
        overTimeLoaded: false,
      };
    case FETCH_TRAVEL_PAST_OVER_TIME_ERROR:
      return {
        ...state,
        overTimeError: true,
      };
    case SET_TRAVEL_PAST_OVER_TIME:
      return {
        ...state,
        overTimeLoaded: action.data.length > 0,
        overTimeData: action.data,
      };
    case FETCH_TRAVEL_PAST_DAILY_AVERAGES:
      return {
        ...state,
        dailyAveragesLoaded: false,
      };
    case FETCH_TRAVEL_PAST_DAILY_AVERAGES_ERROR:
      return {
        ...state,
        dailyAveragError: true,
      };
    case SET_TRAVEL_PAST_DAILY_AVERAGES:
      return {
        ...state,
        dailyAveragesLoaded: true,
        dailyAveragesData: action.data,
      };
    case FETCH_TRAVEL_PAST_POIS:
      return {
        ...state,
        poisLoaded: false,
      };
    case FETCH_TRAVEL_PAST_POIS_ERROR:
      return {
        ...state,
        poError: true,
      };
    case SET_TRAVEL_PAST_POIS:
      return {
        ...state,
        poisLoaded: true,
        poisData: action.data,
      };
    case FETCH_TRAVEL_PAST_REPEAT_DEVICES:
      return {
        ...state,
        repeatDevicesLoaded: false,
      };
    case FETCH_TRAVEL_PAST_REPEAT_DEVICES_ERROR:
      return {
        ...state,
        repeatDevicError: true,
      };
    case SET_TRAVEL_PAST_REPEAT_DEVICES:
      return {
        ...state,
        repeatDevicesLoaded: true,
        repeatDevicesData: action.data,
      };
    case DOWNLOAD_TRAVEL_PAST_INSIGHTS:
      return {
        ...state,
        downloadingCSV: true,
        csvType: action.csvType,
      };
    case DOWNLOAD_TRAVEL_PAST_INSIGHTS_SUCCESS:
      return {
        ...state,
        downloadingCSV: false,
      };
    case DOWNLOAD_TRAVEL_PAST_INSIGHTS_FAILURE:
      return {
        ...state,
        downloadingCSV: false,
      };
    default:
      return {
        ...state,
      };
  }
}

export default travelPast;
